import { createStore, ObservableMap } from '@stencil/store';
import { ConfigQuery, CountriesEnum, LocalesEnum, RegionsEnum } from '../generated/operations';
import { IOfflineStorage } from '../offline-storage';
import { ApolloClient, InMemoryCache } from '@apollo/client/core';
import { ApolloCache } from '@apollo/client/cache';
import { NormalizedCacheObject } from '@apollo/client/cache/inmemory/types';
import { DatabaseClient } from '../database/databaseClient';
import { CachedValue } from 'src/types/CachedValue';
import { UserSettings } from 'src/types/UserSettings';

type HandledFieldsKeys = 'config' | 'apollo' | 'currentLocale';

export interface IState {
  enableOffline: boolean;
  database: DatabaseClient | null;
  apollo: ApolloClient<any> | null;
  apolloCache: ApolloCache<NormalizedCacheObject>;
  root: string;
  config: ConfigQuery | null;
  isRegionDetected: boolean;
  oldState: {
    settings: UserSettings,
    config: ConfigQuery,
  } | null;
  currentLocaleAndRegion: { locale: LocalesEnum, region: RegionsEnum };
  currentLocale: LocalesEnum;
  currentRegion: RegionsEnum;
  currentCountry: CountriesEnum;
  shoppingCenter: string;
  imagesProxyUri: string | null;
  cdnUri: string | null;
  apiUri: string | null;
  offlineStorage: IOfflineStorage | null;
  isFeedbackPopupVisible: boolean;
  gaPush: (event: any) => void;
  dbCache: Map<string, CachedValue>;
  offlineInitSuccess: boolean,
}

export type IStore = ObservableMap<IState>;

export type IInitStoreParams = {
  store: IStore;
} & {
  [Key in HandledFieldsKeys as `${Key}Handler`]: (newValue: IState[Key]) => void;
};

const initialStore: IState = {
  enableOffline: false,
  apiUri: 'http://localhost:3232/',
  database: null,
  apollo: null,
  apolloCache: new InMemoryCache(),
  config: null,
  isRegionDetected: false,
  root: '/',
  oldState: null,
  currentLocaleAndRegion: { locale: LocalesEnum.EnGb, region: RegionsEnum.Eu },
  currentLocale: LocalesEnum.EnGb,
  currentRegion: RegionsEnum.Eu,
  currentCountry: CountriesEnum.Ch,
  shoppingCenter: '',
  imagesProxyUri: null,
  cdnUri: null,
  offlineStorage: null,
  isFeedbackPopupVisible: false,
  gaPush: () => null,
  dbCache: new Map(),
  offlineInitSuccess: false,
};

export const store = createStore<IState>(initialStore);
